import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl, formatAndThrowApiError } from '@/helpers/api';

export const useFees = () => {
  const urlStr = `${getApiUrl()}/fee`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const response = await axios.get(url);
        return response.data;
      } catch (err) {
        formatAndThrowApiError(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const usePostFee = () => {
  const postFee = async (payload) => {
    try {
      const url = `${getApiUrl()}/mega/fee`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return postFee;
};

export const usePutFee = () => {
  const putFee = async (id, payload) => {
    try {
      const url = `${getApiUrl()}/mega/fee/${id}`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return putFee;
};

export const useDeleteFee = () => {
  const deleteFee = async (id) => {
    try {
      const url = `${getApiUrl()}/mega/fee/${id}`;
      const response = await axios.delete(url);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return deleteFee;
};
